import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'gatsby';

import { useLocation } from '@reach/router';

import Minus from '../../assets/icons/minus.png';
import Plus from '../../assets/icons/plus.png';
import { download } from '../../utils/download';
import { IFooterLinks } from '../footer/helpers';

import {
	ScNavigationAccordionContent,
	ScNavigationAccordionItem,
	ScNavigationAccordionItemTitle,
} from './styled';

export const Index = ({
	item,
	openModal,
}: {
	item: IFooterLinks;
	openModal?: (modalType: string) => void;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();
	useEffect(() => {
		setIsOpen(false);
	}, [location]);

	return (
		<ScNavigationAccordionItem key={item.title}>
			<ScNavigationAccordionItemTitle>
				{item.link ? (
					<Link to={item.link}>{item.title}</Link>
				) : item.group ? (
					<button type="button" onClick={() => setIsOpen(!isOpen)}>
						{item.title}
					</button>
				) : (
					item.title
				)}
				{item.group && (
					<button
						type="button"
						onClick={() => setIsOpen(!isOpen)}
						aria-label={isOpen ? `Collapse ${item.title}` : `Expand ${item.title}`}
					>
						{isOpen ? (
							<img src={Minus} alt="Collapse" style={{ height: '6px' }} />
						) : (
							<img src={Plus} alt="Expand" />
						)}
					</button>
				)}
			</ScNavigationAccordionItemTitle>
			{isOpen && item.group && (
				<ScNavigationAccordionContent>
					{item.group.map((el) =>
						el.isContactUsItem && openModal ? (
							<button key={el.title} type="button" onClick={() => openModal(el.keyword)}>
								{el.title}
							</button>
						) : el.isItDownloadLink ? (
							<button key={el.title} type="button" onClick={() => download(el.link)}>
								{el.title}
							</button>
						) : el.isExternalLink ? (
							<a key={el.title} href={el.link}>
								{el.title}
							</a>
						) : (
							<Link key={el.title} to={el.link}>
								{el.title}
							</Link>
						),
					)}
				</ScNavigationAccordionContent>
			)}
		</ScNavigationAccordionItem>
	);
};
